<template>
  <div :class="$style.box">
    <img :src="icon" alt="" />
    <input
      :type="inputType"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :style="{ width: type === 3 ? '60%' : '90%' }"
    />
    <div :class="$style.code" v-if="type === 3" @click="getCode">
      {{ time === 0 ? "发送验证" : `${time}s后重试` }}
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { regList } from "../config";
import { sendCode } from "@/apis/gameJump";
import { mapState } from "vuex";

export default {
  props: {
    // 输入框类型
    type: {
      type: Number,
      default: 0, // 1.输入框 2.密码框 3.验证码
    },
    // 提示
    placeholder: {
      type: String,
      default: "请输入",
    },
    // 左边icon
    icon: {
      type: String,
      default: "",
    },
    // 数据绑定
    value: {
      type: String,
      default: "",
    },
    // 手机号码，在验证码时需要用于判断
    phone: {
      type: String,
      default: "",
    },
  },
  computed: {
    inputType() {
      let type = "";
      switch (this.type) {
        case 1:
          type = "input";
          break;
        case 2:
          type = "password";
          break;
        case 3:
          type = "input";
          break;
        default:
          type = "input";
          break;
      }
      return type;
    },
  },
  data() {
    return {
      timer: null, // 倒计时timer
      time: 0, // 倒计时
      appkey: '' // http://h5.hzwxbz3.cn/wechat/game-bind/url?appkey=100008780
    };
  },
  mounted() {
    this.appkey = this.$route.query.appkey;
  },
  methods: {
    // 倒计时
    async getCode() {
      if (this.time !== 0) return;
      // 先判断手机号是否通过验证
      const { phone } = regList;
      const regExp = new RegExp(phone);
      if (!regExp.test(this.phone)) {
        Toast.fail("手机号有误，请检查后重新填写");
        return;
      }
      console.log("请求接口", this.appkey);
      const { ret } = await sendCode({
        tel_num: this.phone,
        jh_app_id: this.appkey,
        type: "bind",
      });
      if (ret !== 1) {
        Toast.fail("发送失败！");
        return;
      }
      Toast.success("发送成功！");
      // 倒计时启动
      this.time = 60;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.time !== 0) {
          this.time -= 1;
          return;
        }
        clearInterval(this.timer);
        this.timer = null;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 271px;
  height: 39px;
  border-radius: 18px;
  background: #f2f2f2;
  padding: 0px 18px;
  display: flex;
  align-items: center;
  > img {
    width: 13px;
    margin-right: 8px;
  }
  > input {
    background: #f2f2f2;
    color: #000;
    font-size: 14px;
  }
  .code {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #898989;
    line-height: 14px;
  }
}
</style>